import React, { useState } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { deleteDesignations, postActiveDesignations } from "../../../../../MyApi/hr/designations";

import icons from "../../../../../Data/icons";

const SingleDesignations = ({ attend, classes ,refetch }) => {
  const { id,name,branch,department , active} = attend;
  const [activeState ,setActive]=useState(active)
  const navigate = useNavigate()

  const EditPen= icons.pen
  const mutation =useMutation(["deleteDesignations" , id] , ()=>deleteDesignations(id),{
    onSuccess:(data)=>{
     toast.success(`${data.message}`)
     refetch()
  
    },
    onError:(error)=>{
      toast.error(`${error.data.response.message}`)
    }
  })
  const mutationActive = useMutation(
    ["postActive", id],
    (postData) => postActiveDesignations(postData, id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        refetch();
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );
  
  const handelChangeActive = (e) => {
    const isChecked = e.target.checked;
    const newActiveState = isChecked ? 1 : 0;
  
    setActive(newActiveState);
    mutationActive.mutate({
      active: newActiveState,
    });
  }
  

  const deletePost =()=>{   
    mutation.mutate()
  }

  return (
    <tr>
      <td><b>{name} #{id}</b><br></br>{branch}</td>
      <td>{department}</td>
      <td>
      <div>
            <label class="switch">
              <input
                type="checkbox"
                onChange={handelChangeActive}
                checked={activeState}
              />
              <span class="slider round"></span>
            </label>
          </div>
      </td>
      
      <td >   
        <div>
          <div role="group" class="btn-group">
            <button class="btn btn-success" onClick={()=>navigate(`${process.env.PUBLIC_URL}/designation/${id}`)}><i class="fa fa-eye"></i></button>
            <button class="btn btn-secondary"  onClick={()=>navigate(`${process.env.PUBLIC_URL}/designationsupdate/${id}`)}><EditPen/></button>
           <button class="btn btn-danger" onClick={deletePost}><i class="fa fa-trash"></i></button></div>
           </div>
      </td>
      
    </tr>
  );
};

export default SingleDesignations;
